import React from 'react';

import artwork from '../../../../Assets/Linkages/SpaceOutreachFilm/Jahan-Aur-Bhi-Hain-Artwork.png';

const JahanAurBhiHain = () => (
  <section className="outreach-film-feature" aria-labelledby="outreach-film-feature-title">
    <div className="outreach-film-feature-inner">
      <figure className="outreach-film-feature-artwork">
        <img src={artwork} alt="Jahan Aur Bhi Hain — Beyond the Blue telefilm artwork" />
      </figure>

      <div className="outreach-film-feature-copy">
        <p className="section-eyebrow">SCIENCE THROUGH STORYTELLING</p>
        <h1 id="outreach-film-feature-title">Jahan Aur Bhi Hain — Beyond the Blue</h1>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          A telefilm that shows how technology helps us face the growing challenges of climate
          change. A collaboration between researchers and filmmakers, it blends science fiction
          with real-world environmental issues. By transforming complex science into compelling
          cinema, Jahan Aur Bhi Hain sparks understanding and inspires action for a sustainable future.
        </p>
        <a
          className="outreach-film-trailer-link"
          href="https://www.youtube.com/watch?v=ZFk8pPvkL0w"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Watch the Jahan Aur Bhi Hain trailer on YouTube"
        >
          Watch Trailer <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </section>
);

export default JahanAurBhiHain;
